<template>
  <div>
    <pagination ref="parentList" v-loading="loading" :data="pageData" :option="paginationOption" @search="search" @add="add" @edit="edit">
      <template #Enable="{row}">
        <span>{{row.Enable ? '启用' : '停用'}}</span>
      </template>
      <template #Students="{row}">
        <span>{{row.Students.map(item => item.Phone).join()}}</span>
      </template>
    </pagination>
    <parentAccountEditor ref="parentAccountEditor" :data="editData" @close="onParentAccountEditorClose" @saveSuccess="onParentAccountEditorSaveSuccess" />
  </div>
</template>

<script>
import { getParentPageData } from "@/service/parent.service";

export default {
  name: "parentAccountList",
  components: {
    pagination: () => import("../common/pagination"),
    parentAccountEditor: () => import("./parentAccountEditor")
  },
  props: {},
  data() {
    return {
      loading: false,
      paginationOption: {},
      pageData: [],
      searchKeyword: String.empty,
      editData: null,
    };
  },
  created() {
    this.init();
  },
  methods: {
    // 与服务端交互数据相关方法
    async loadParentPageDataFromServer(keyword) {
      this.loading = true;
      try {
        let result = await getParentPageData(keyword);
        this.pageData =
          !!result && result.success && !!result.data ? result.data : [];
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    init() {
      let canEdit = !this.USERMANAGER.isSAFinancialAssistant;
      this.paginationOption = {
        displayPagination: false,
        hasEditButton: canEdit,
        editButtonText: "编辑账号",
        hasAddButton: canEdit,
        addButtonText: "添加家长",
        hasSearch: true,
        fnRowEditVisible: this.onRowEditVisible,
        fnCustomCellClass: (col, row) => {
          return {
            "color-status": col.IsColorLabel,
            "color-status-inProgress": row.Enable,
            "color-status-completed":
              false,
            "color-status-closed":
              false,
          };
        },
      };

      this.loadParentPageDataFromServer();
    },
    onRowEditVisible(index, row) {
      if (this.USERMANAGER.isAdmin || this.USERMANAGER.isPersonnelManagement)
        return true;

      return row.RoleId !== this.GLOBAL.roleType.executiveManager && row.RoleId !== this.GLOBAL.roleType.financialManager;
    },
    search(keyword) {
      this.searchKeyword = keyword;
      this.loadParentPageDataFromServer(keyword);
    },
    add() {
      let { parentAccountEditor } = this.$refs;
      if (!parentAccountEditor) return;

      this.editData = null;
      parentAccountEditor.showDialog();
    },
    edit(index, row) {
      let { parentAccountEditor } = this.$refs;
      if (!parentAccountEditor) return;

      this.editData = row;
      parentAccountEditor.showDialog();
    },
    onParentAccountEditorClose() {
      this.editData = null;
    },
    onParentAccountEditorSaveSuccess(data) {
      //if (data && data.isAdd){
      if (this.USERMANAGER.isSANormal && data){
        this.$refs.parentList.setSearchWord(data.phone);
        this.loadParentPageDataFromServer(data.phone);
      }else{
        this.loadParentPageDataFromServer();
      }
      
    }
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/parentAccount/parentAccountList.vue